import React, { Component } from "react";
/* import Leaflet from 'leaflet'; */
import L from "leaflet";
import { CordConverter } from "./CordConverter.js";
import {
  Map,
  TileLayer,
  Marker,
  LayersControl,
  WMSTileLayer,
  Tooltip,
  Popup,
  Circle,
  LayerGroup,
} from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-markercluster";
import "leaflet/dist/leaflet.css";
import "react-leaflet-markercluster/dist/styles.min.css";
import "./Maps.css";
import HelpOutlineRoundedIcon from "@material-ui/icons/HelpOutlineRounded";
import MuiTooltip from "@material-ui/core/Tooltip";
import {
  createTheme,
  MuiThemeProvider,
  withStyles,
} from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

const toolTheme = createTheme();
const theme = createTheme({
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: "0.8em",
        color: "#2A2A2A",
        backgroundColor: "white",
      },
    },
  },
});

const markerTotPrvCpt = {
  inactive: new L.Icon({
    iconUrl: require("../tot_prv_cpt-grey.svg"),
    iconSize: [45, 45],
  }),
  active: new L.Icon({
    iconUrl: require("../tot_prv_cpt.svg"),
    iconSize: [45, 45],
  }),
};

const markerTotPrv = {
  inactive: new L.Icon({
    iconUrl: require("../tot_prv-grey.svg"),
    iconSize: [40, 40],
  }),
  active: new L.Icon({
    iconUrl: require("../tot_prv.svg"),
    iconSize: [40, 40],
  }),
};

const markerTotCpt = {
  inactive: new L.Icon({
    iconUrl: require("../tot_cpt-grey.svg"),
    iconSize: [40, 40],
  }),
  active: new L.Icon({
    iconUrl: require("../tot_cpt.svg"),
    iconSize: [40, 40],
  }),
};

const markerTot = {
  inactive: new L.Icon({
    iconUrl: require("../tot-grey.svg"),
    iconSize: [20, 20],
  }),
  active: new L.Icon({
    iconUrl: require("../tot_active.svg"),
    iconSize: [20, 20],
  }),
};

export default class MapDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      convertedCoordinates: [],
      bounds: null,
    };
    this.cordZones = [
      "UTM32",
      "UTM33",
      "UTM35",
      "NTM5",
      "NTM6",
      "NTM7",
      "NTM8",
      "NTM9",
      "NTM10",
      "NTM11",
      "NTM12",
      "NTM13",
      "NTM14",
      "NTM15",
      "NTM16",
      "NTM17",
      "NTM18",
      "NTM19",
      "NTM20",
      "NTM21",
      "NTM22",
      "NTM23",
      "NTM24",
      "NTM25",
      "NTM26",
      "NTM27",
      "NTM28",
      "NTM29",
      "NTM30",
    ];
    this.handleCheck = this.props.handleCheck.bind(this);

    // adds
    this.layerNameOn = true;
  }

  componentDidMount() {
    // Access the Leaflet map instance and set the view with desired center and zoom
    const map = this.refs.map.leafletElement;
    const bounds=this.getMapBounds()
    const defaultCenter = [bounds["_northEast"]["lat"],bounds["_northEast"]["lng"]]; // Adjust the center coordinates
    const defaultZoom = 12; // Adjust the zoom level
    map.setView(defaultCenter, defaultZoom);
  }

  

  handleZoneChange = (event) => {
    // let newCoordinateSystem = this.props.currentCoordinateSystem;

    // newCoordinateSystem.zone = event.target.value.slice(0, 3);
    // newCoordinateSystem.number = parseInt(event.target.value.slice(3, 5));
    const selectedValue = event.target.value;
    console.log(selectedValue);
    let newCoordinateSystem = this.props.crs.filter(
      (crs) => crs.srid.toString() === selectedValue
    )[0];
    this.props.onCoordinateSystemChange(newCoordinateSystem);
  };

  handleLabelOnMarker = (event) => {
    this.layerNameOn = event.target.checked;
    //uses this to trigger a rerender
    this.props.onCoordinateSystemChange(this.props.currentCoordinateSystem);
  };

  handleHemisphereChange = (event) => {
    let newCoordinateSystem = this.props.currentCoordinateSystem;
    newCoordinateSystem.hemisphere = event.target.value;
    this.props.onCoordinateSystemChange(newCoordinateSystem);
  };

  getMarker = (id) => {
    let markerType;
    if (this.props.boreholeList[id].CPT !== null) {
      if ("PRV" in this.props.boreholeList[id] && this.props.boreholeList[id].PRV != null) {
        markerType = markerTotPrvCpt;
      } else {
        markerType = markerTotCpt;
      }
    } else {
      if ("PRV" in this.props.boreholeList[id] && this.props.boreholeList[id].PRV != null) {
        if (this.props.boreholeList[id].PRV != null) {
          markerType = markerTotPrv;
        } else {
          markerType = markerTot;
        }
      } else {
        markerType = markerTot;
      }
    }
    let marker = markerType.inactive;

    if (this.props.checkedFiles.includes(id)) {
      let marker = markerType.active;
      return marker;
    }
    return marker;
  };

  markerOnClick = (e, id) => {
    this.handleCheck(e, id);
  };

  markerDblclick = (id) => {
    this.props.updateDetailedView(id);
    let element = document.getElementById("detailedView");
    if (element != null) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    console.log("Doubleclicked");
  };

  convertCoordinates = (file) => {
    let x = file.SND_METADATA.x;
    let y = file.SND_METADATA.y;
    //convert to active coordinate system.
    //quick fix to convert to umt32N
    let coord = {
      easting: y,
      northing: x,
      zone: this.props.currentCoordinateSystem.zone,
      number: this.props.currentCoordinateSystem.number,
      hemisphere: this.props.currentCoordinateSystem.hemisphere,
    };
    coord = CordConverter(coord);
    coord.index = file.INDEX;
    //this.handleAddCoordinate(coord);
    return coord;
  };

 

  getMapBounds = () => {
    let bounds;
    let convertedCoordinates = Object.values(this.props.boreholeList).map(
      (file) => [this.convertCoordinates(file)]
    );
    if (convertedCoordinates[0] !== undefined) {
      bounds = L.latLngBounds(convertedCoordinates);
    } else {
      bounds = L.latLngBounds([59.889802, 10.52075], [59.891802, 10.52275]); //startposisjon i sandvika
    }
    return bounds;
  };

  render() {
    let wms_overlay = [
      {
        name: "Høydekurver",
        url: "https://openwms.statkart.no/skwms1/wms.topo4?",
        layers: ["Hoydekurver", "Hoydepunkt"],
        attribution: "Statkart",
      },
      {
        name: "Kvikkleiresoner",
        url: "https://nve.geodataonline.no/arcgis/services/SkredKvikkleire2/MapServer/WmsServer?",
        layers: ["KvikkleireFaregrad"],
        attribution: "NVE",
      },
      {
        name: "Løsmasser",
        url: "http://geo.ngu.no/mapserver/LosmasserWMS",
        layers: ["Losmasse_flate_label"],
        attribution: "NGU",
        opacity: 0.5,
      },
      {
        name: "Nadag grunnundersøkelser",
        url: "http://geo.ngu.no/geoserver/nadag/wms",
        layers: ["GBU_borefirma", "GB_filter_kvikk"],
        attribution: "NGU",
      },
      {
        name: "Statens vegvesen grunnundersøkelser",
        url: "https://www.vegvesen.no/kart/ogc/rapportweb_1_0/ows",
        layers: ["Rapportwebgeoteknikk"],
        attribution: "Statens vegvesen",
      },
      {
        name: "Marin grense",
        url: "http://geo.ngu.no/mapserver/MarinGrenseWMS3",
        layers: ["MarinGrenseWMS3"],
        attribution: "NGU",
      },
      {
        name: "Bratthet",
        url: "https://nve.geodataonline.no/arcgis/services/Bratthet/MapServer/WmsServer?",
        layers: ["Bratthet_jordskred"],
        attribution: "NVE",
        opacity: 0.5,
      },
      {
        name: "Berggrunn",
        url: "http://geo.ngu.no/mapserver/BerggrunnWMS2",
        layers: [""],
        attribution: "NGU",
      },
      {
        name: "Ortofoto",
        url: "https://wms.geonorge.no/skwms1/wms.nib?",
        layers: ["ortofoto"],
        attribution: "GeoNorge",
        opacity: 0.5,
      },
      {
        name: "Høydedata",
        url: "https://opencache.statkart.no/gatekeeper/gk/gk.open_gmaps?layers=topo4graatone&zoom={z}&x={x}&y={y}",
        attribution: "Kartverket",
      },
      {
        name: "Ortofoto",
        url: "https://wms.geonorge.no/skwms1/wms.hoyde-dtm?",
        layers: ["DTM:skyggerelieff"],
        attribution: "Skyggekart",
      },
    ];
    let bounds = this.getMapBounds();
    return (
      <div id="map" className="maps">
        <span>
          <h1 className="maps-h1">
            Kartvisning
            <MuiThemeProvider theme={theme}>
              <MuiTooltip placement="top-start" title="Kartforklaring" arrow>
                <HelpOutlineRoundedIcon
                  className="helpIcon helpIcon-map"
                  style={{ color: "#2b5279" }}
                />
              </MuiTooltip>
            </MuiThemeProvider>
          </h1>
        </span>
        <div className="maps-header">
          <span className="map-zones">
            <h3 className="maps-h3">Koordinatsystem</h3>
            <span className="zone-input">
              <select
                id="zone"
                onChange={(e) => {
                  this.handleZoneChange(e);
                }}
                value={this.props.currentCoordinateSystem.srid}
              >
                {this.props.crs.map((crs) => {
                  return (
                    <option value={crs.srid}>
                      {crs.number != null
                        ? crs.zone + crs.number
                        : crs.zone + ""}
                    </option>
                  );
                })}
              </select>
              {/* <ul>
                <li key="north-option">
                  <input
                    type="radio"
                    name="hemisphere"
                    id="n-option"
                    value="N"
                    onChange={(e) => {
                      this.handleHemisphereChange(e);
                    }}
                    checked={
                      this.props.currentCoordinateSystem.hemisphere === "N"
                    }
                  />
                  <label className="hemisphere-label" htmlFor="n-option">
                    North
                  </label>
                  <span className="check"></span>
                </li>
                <li key="south-option">
                  <input
                    type="radio"
                    name="hemisphere"
                    id="s-option"
                    value="S"
                    onChange={(e) => {
                      this.handleHemisphereChange(e);
                    }}
                    checked={
                      this.props.currentCoordinateSystem.hemisphere === "S"
                    }
                  />
                  <label className="hemisphere-label" htmlFor="s-option">
                    South
                  </label>
                  <span className="check"></span>
                </li>
              </ul> */}

              <input
                type="checkbox"
                name="labelOnName"
                id="s-option"
                value={this.layerNameOn}
                checked={this.layerNameOn}
                onChange={(e) => {
                  this.handleLabelOnMarker(e);
                }}
              />
              <label className="hemisphere-label" htmlFor="n-option">
                Names
              </label>

              <div style={{ marginLeft: "500px" }}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={this.props.postSridToProject}
                >
                  Set coordinatsystem on project
                </Button>
              </div>
            </span>
          </span>
        </div>

        <div className="maps-left"></div>
        <Map
          ref="map"
          className="markercluster-map"
          bounds={bounds}
          doubleClickZoom={true}
          style={{ width: "100%", height: "1200px" }}
        >
          <LayersControl position="topright" expanded="true" align="left">
            <LayersControl.BaseLayer
              name="Kartverket"
              checked="true"
              key="Kartverket"
            >
              <TileLayer
                attribution="Kartverket"
                url="https://opencache.statkart.no/gatekeeper/gk/gk.open_gmaps?layers=topo4graatone&zoom={z}&x={x}&y={y}"
                maxZoom={30}
              ></TileLayer>
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer
              name="OpenStreetmap"
              checked="false"
              key="openstreetmap"
            >
              <TileLayer
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                maxZoom={30}
              ></TileLayer>
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="Ortofoto" key="ortofoto">
              <WMSTileLayer
                attribution="Google"
                url="https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                layers="ortofoto"
                format="image/png"
                version="1.3.1"
                transparent="true"
                maxZoom={30}
              ></WMSTileLayer>
            </LayersControl.BaseLayer>
            {wms_overlay.map((wms, index) => {
              return (
                <LayersControl.Overlay name={wms["name"]} key={index}>
                  <WMSTileLayer
                    attribution={wms["attribution"]}
                    url={wms["url"]}
                    layers={wms["layers"]}
                    version="1.3.0"
                    format="image/png"
                    transparent="true"
                    opacity={"opacity" in wms ? wms["opacity"] : 1}
                  ></WMSTileLayer>
                </LayersControl.Overlay>
              );
            })}
          </LayersControl>
          <MarkerClusterGroup disableClusteringAtZoom={15}>
            {Object.entries(this.props.boreholeList).map(([key, file]) => {
              let coord = this.convertCoordinates(file);
              let coordtext = coord.lat + ", " + coord.lng;
              let icon = this.getMarker(key);
              let clay_data = [];
              let circleColor = "green";

              for (let i = 0; i < file.DYNAMIC_DATA.length; i++) {
                const { type, probability } = file.DYNAMIC_DATA[i];
                if (type === "Kvikkleire") {
                  circleColor = "red";
                  break;
                } else if (
                  type === "Leire" ||
                  type === "Udrenert" ||
                  type === "Silt"
                ) {
                  if (probability >= 0.6) {
                    circleColor = "orange";
                    break;
                  } else {
                    circleColor = "yellow";
                  }
                  clay_data.push(file.DYNAMIC_DATA[i]);
                }
              }

              // const quickclayData = file.DYNAMIC_DATA.filter(item => {
              //     const { type, probability } = item;
              //     return (type === 'Kvikkleire' || (type === 'Leire' && probability > 0.6) || (type === 'Udrenert' && probability > 0.6));
              //   });

              // if (!quickclayData.length > 0) {
              //     clay_data=file.DYNAMIC_DATA.filter(item => {
              //         const { type, probability } = item;
              //         return ( (type === 'Leire') || (type === 'Udrenert') || (type === 'Silt'));
              //       });
              // }
              return (
                <LayerGroup key={key}>
                  {(circleColor === "red" || circleColor === "orange") && (
                    <Circle
                      center={coord}
                      radius={15}
                      color={circleColor}
                      fill={false}
                    >
                      <Tooltip >Sannsynlig kvikkleire</Tooltip>
                    </Circle>
                  )}
                  {circleColor === "yellow" && clay_data.length > 0 && (
                    <Circle
                      center={coord}
                      radius={15}
                      color={circleColor}
                      fill={false}
                    >
                      <Tooltip >Sondering har innhold av leire</Tooltip>
                    </Circle>
                  )}
                  {circleColor === "green" && (
                    <Circle
                      center={coord}
                      radius={15}
                      color={circleColor}
                      fill={false}
                    >
                      <Tooltip >Sondering har ikke innhold av leire</Tooltip>
                    </Circle>
                  )}

                  <Marker
                    className="marker-popup"
                    icon={icon}
                    position={coord}
                    title={coordtext}
                    onclick={(e) => this.markerOnClick(e, key)}
                    ondblclick={() => this.markerDblclick(key)}
                    key={key}
                  >
                    {this.layerNameOn && (
                      <Tooltip
                        permanent="true"
                        direction="top"
                        offset={[0, -45]}
                        key={"tooltip-" + key}
                      >
                        <p className="file-tooltip" id="fileTooltip">
                          {file.BORHOLE_NAME}
                        </p>
                      </Tooltip>
                    )}

                    {/* <Popup>
                                        <p>{file.BORHOLE_NAME}</p>
                                        <h2>Where does it come from?
Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.</h2>
                                    </Popup> */}
                  </Marker>
                </LayerGroup>
              );
            })}
          </MarkerClusterGroup>
        </Map>
      </div>
    );
  }
}
